import { FC, useMemo } from 'react';
import { Button, Icon } from '@livechat/design-system-react-components';
import {
  GoogleLightModeColored as GoogleIcon,
  WindowsOriginal as WindowsIcon,
  Apple as AppleIcon,
} from '@livechat/design-system-icons';

import * as styles from './styles';

type Props = {
  onClick: any;
  company: string;
  caption: string;
};

export const LoginWithButton: FC<Props> = ({ caption, company, onClick }) => {
  const companyIcon = useMemo(() => {
    switch (company) {
      case 'Google':
        return GoogleIcon;
      case 'Microsoft':
        return WindowsIcon;
      case 'Apple':
        return AppleIcon;
      default:
        return null;
    }
  }, [company]);

  return (
    <Button
      onClick={onClick}
      kind="secondary"
      size="large"
      icon={<Icon source={companyIcon} />}
      css={styles.button}
    >
      {caption} {company}
    </Button>
  );
};
